import React, { useState, useEffect } from "react";
import axios from "axios";
import "../MPHomeShowImages.css"; // We'll create this CSS file
import { MyDomain } from "../../App";
import { useAppContext } from "../../AppContext";
import { useTranslation } from "react-i18next";

export default function MPHomeShowImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const { t, i18n } = useTranslation();

  const {
    OpenDrawer,
    setOpenDrawer,
    ObjectData,
    setObjectData,
    AllApps,
    Loading,
    ChoosedDate,
    setChoosedDate,
    ChoosedApps,
    setChoosedApps,
    AllData,
    SelectedServices,
    setSelectedServices,
    User,
    setUser,
    OtherBarbers,
  } = useAppContext();
  useEffect(() => {
    fetchImages();
  }, [AllData.barberData.id]);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${MyDomain}Barbers2/GetAllImagesByBarberId/${AllData.barberData.id}`
      );
      setImages(response.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return (
      <div className="gallery-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading gallery...</p>
        </div>
      </div>
    );
  }

  if (!images || images.length === 0) {
    return (
      <div className="gallery-container">
        <div className="empty-state">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
          <p>No images available yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="gallery-container">
        <h3 className="gallery-title">{t("Gallery")}</h3>
        <div className="gallery-scroll">
          {images.map((item) => (
            <div
              key={item.id}
              className="gallery-item"
              onClick={() => openLightbox(item.image)}
            >
              <img
                src={item.image}
                alt={`Gallery ${item.id}`}
                className="gallery-image"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="white"
                  stroke="white"
                  strokeWidth="2"
                >
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                  <line x1="11" y1="8" x2="11" y2="14" />
                  <line x1="8" y1="11" x2="14" y2="11" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="lightbox-close" onClick={closeLightbox}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <img
              src={selectedImage}
              alt="Full size"
              className="lightbox-image"
            />
          </div>
        </div>
      )}
    </>
  );
}
